import {
  createAdminDiscountCodeApi,
  deleteAdminDiscountCodeApi,
  fetchAdminDiscountCodesApi,
  updateAdminDiscountCodeApi,
} from '../../util/api';

const ns = 'app/AdminPanelDiscountCodesPage';

export const FETCH_DISCOUNT_CODES_REQUEST = `${ns}/FETCH_DISCOUNT_CODES_REQUEST`;
export const FETCH_DISCOUNT_CODES_SUCCESS = `${ns}/FETCH_DISCOUNT_CODES_SUCCESS`;
export const FETCH_DISCOUNT_CODES_ERROR = `${ns}/FETCH_DISCOUNT_CODES_ERROR`;
export const MUTATE_DISCOUNT_CODE_REQUEST = `${ns}/MUTATE_DISCOUNT_CODE_REQUEST`;
export const MUTATE_DISCOUNT_CODE_SUCCESS = `${ns}/MUTATE_DISCOUNT_CODE_SUCCESS`;
export const MUTATE_DISCOUNT_CODE_ERROR = `${ns}/MUTATE_DISCOUNT_CODE_ERROR`;

const getErrorMessage = error =>
  error?.message || error?.error || 'Something went wrong. Please try again.';

const initialState = {
  coupons: [],
  fetchInProgress: false,
  fetchError: null,
  mutationInProgress: false,
  mutationError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DISCOUNT_CODES_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_DISCOUNT_CODES_SUCCESS:
      return { ...state, fetchInProgress: false, coupons: action.payload || [] };
    case FETCH_DISCOUNT_CODES_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.payload };
    case MUTATE_DISCOUNT_CODE_REQUEST:
      return { ...state, mutationInProgress: true, mutationError: null };
    case MUTATE_DISCOUNT_CODE_SUCCESS:
      return { ...state, mutationInProgress: false };
    case MUTATE_DISCOUNT_CODE_ERROR:
      return { ...state, mutationInProgress: false, mutationError: action.payload };
    default:
      return state;
  }
}

export const fetchDiscountCodes = () => async dispatch => {
  dispatch({ type: FETCH_DISCOUNT_CODES_REQUEST });
  try {
    const response = await fetchAdminDiscountCodesApi();
    const coupons = response?.coupons || [];
    dispatch({ type: FETCH_DISCOUNT_CODES_SUCCESS, payload: coupons });
    return coupons;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch({ type: FETCH_DISCOUNT_CODES_ERROR, payload: message });
    throw error;
  }
};

const mutateAndRefresh = request => async dispatch => {
  dispatch({ type: MUTATE_DISCOUNT_CODE_REQUEST });
  try {
    const response = await request();
    dispatch({ type: MUTATE_DISCOUNT_CODE_SUCCESS });
    await dispatch(fetchDiscountCodes());
    return response;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch({ type: MUTATE_DISCOUNT_CODE_ERROR, payload: message });
    throw error;
  }
};

export const createDiscountCode = payload =>
  mutateAndRefresh(() => createAdminDiscountCodeApi(payload));

export const updateDiscountCode = (couponId, payload) =>
  mutateAndRefresh(() => updateAdminDiscountCodeApi(couponId, payload));

export const deleteDiscountCode = couponId =>
  mutateAndRefresh(() => deleteAdminDiscountCodeApi(couponId));

export const loadData = () => () => Promise.resolve();
